/**
 * 도급사업 안전보건 협의체 회의록 그리드 컬럼 정의
 * SUB_BASIC_03 화면 전용 컬럼 정의
 */

import CreateColumn from '../../../../Services/agGrid/createColumn';
import { Button } from '../../../../Components/MUIs';

/** 서명요청 이후 회의록 수정 잠금 */
export const IsMeetingMinutesLocked = (row = {}) => {
  const yn =
    row?.signRequestYn ?? row?.SignRequestYn ?? row?.SIGN_REQUEST_YN ?? 'N';
  return yn === 'Y' || yn === '1' || yn === true;
};

/**
 * 협의체회의록 그리드 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // NO 컬럼 (체크박스 포함)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),
    // 채번 컬럼 (숨김)
    CreateColumn('chaebun', '', 'left', 100, false, false, true, 'text', {
      maxWidth: 100,
    }),
    // 사업장코드 컬럼 (숨김)
    CreateColumn('custCd', '', 'left', 100, false, false, true, 'text', {
      maxWidth: 100,
    }),
    // 회의제목 컬럼
    CreateColumn(
      'proceedingsTitle',
      '회의제목',
      'left',
      350,
      false,
      false,
      false,
      'text',
      {
        width: 350,
        flex: 1,
      }
    ),
    // 회의일시 컬럼
    CreateColumn(
      'proceedingsDate',
      '회의일시',
      'center',
      150,
      false,
      false,
      false,
      'text',
      {
        width: 150,
        valueFormatter: (params) => {
          const date = new Date(params.value);
          if (isNaN(date.getTime())) return '';

          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');

          return `${year}-${month}-${day}`;
        },
      }
    ),
    // 회의장소 컬럼
    CreateColumn(
      'proceedingsLocation',
      '회의장소',
      'center',
      250,
      false,
      false,
      false,
      'text',
      {
        width: 250,
      }
    ),
    // 회의록 첨부파일 컬럼 (클릭 시 다운로드)
    CreateColumn(
      'minutesFileName',
      '회의록 첨부',
      'center',
      200,
      false,
      false,
      false,
      'button',
      {
        minWidth: 160,
        buttonRenderer: (params) => {
          const fileName = params.data?.minutesFileName;
          if (!fileName || !params.data?.minutesFilePath) return '-';
          return (
            <span
              title={`${fileName} 다운로드`}
              style={{
                color: '#1976d2',
                textDecoration: 'underline',
                cursor: 'pointer',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              onClick={(e) => {
                e.stopPropagation();
                props.DownloadMinutesFileLogic?.(params.data);
              }}
            >
              {fileName}
            </span>
          );
        },
      }
    ),
    // 수정 버튼 컬럼
    CreateColumn('', '회의작성', 'center', 120, false, false, false, 'button', {
      minWidth: 120,
      buttonRenderer: (params) => {
        if (params.data?.newYn === 'Y' || params.data?.editYn === 'Y') {
          return null;
        }
        const locked = IsMeetingMinutesLocked(params.data);
        return (
          <Button
            name={locked ? '조회' : '수정'}
            title={
              locked
                ? '서명 요청 후 회의록은 수정할 수 없습니다. (조회만 가능)'
                : undefined
            }
            sx={{ width: '100%' }}
            onClick={() => {
              props.PopupClickEvent2Update(params.data);
              props.PopupClickEvent5(params.data);
            }}
          />
        );
      },
    }),
    // 서명 버튼 컬럼
    CreateColumn('', '서명', 'center', 120, false, false, false, 'button', {
      minWidth: 120,
      buttonText: '요청하기',
      buttonCondition: (params) => {
        return !(params.data?.newYn === 'Y' || params.data?.editYn === 'Y');
      },
      buttonClickHandler: (params) => {
        props.SignRequest('0', params.data);
      },
    }),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
